import { ImageLoader } from "@src/helpers/ImageLoader";
import { ImageCanvasWrapper } from "@src/saunaparts/ImageCanvasWrapper";
import ImageResolution from "@src/saunaparts/ImageResolution";
import { LayerImageRepository, Sauna } from "..";
import { Layer } from "./Layer";

export class DoorWallLayer implements Layer
{
    layerImageRepository:LayerImageRepository;
    sauna:Sauna;
    
    constructor(layerImageRepository:LayerImageRepository,sauna:Sauna)
    {
        this.layerImageRepository =layerImageRepository;
        this.sauna = sauna;
    }
    Render(desiredResolution: ImageResolution): Promise<HTMLCanvasElement> {
        let path = this.layerImageRepository.getglassWallLayer(this.sauna.Model,false,desiredResolution);
        return new ImageLoader(path).Load().then(i=>new ImageCanvasWrapper(i,desiredResolution).getCanvas());
    }
    

}